type ParentEmailNoticeProps = {
  email: string;
};

const ParentEmailNotice = ({ email }: ParentEmailNoticeProps) => {
  return (
    <div className="mt-8">
      <b>Thank you for expressing interest in Cluey+</b>
      <p className="mt-5">
        We have sent an email to {email} advising they will need to complete the enrolment process on your behalf due to
        our minimum age requirement
      </p>
      <p className="mt-5">Looking forward to seeing you on Cluey+.</p>
    </div>
  );
};

export default ParentEmailNotice;
